import { ICON_COLLECTION } from '@tornado-rdk/icons';
import Icon from '../../../tornado/icon/icon.component';
import { defaultContext, ICON_HEIGHT } from './playbackStateIndicator.style';

export const makeIcon = name => ({
  type: Icon,
  iconData: {
    picto: {
      name,
      collection: ICON_COLLECTION.CONTROLS,
    },
    viewBox: {
      h: ICON_HEIGHT[defaultContext.screenSize],
    },
  },
});
